import { useQuery } from "@tanstack/react-query";
import { authPath } from "../../config.json";
import { getEnvSettings } from "../lib/utils";

export function useSessionAuth() {
  const url = getSessionAuthUrl();

  const { data } = useQuery<{
    ok: boolean;
    err?: string;
  }>({
    queryKey: [url],
    enabled: ({ meta }) => !!meta?.token,
    queryFn: async ({ meta }) => {
      const res = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${meta?.token}`,
        },
      });
      return {
        ok: res.ok,
        err: res.ok ? undefined : res.statusText,
      };
    },
  });

  return {
    ok: data?.ok ?? false,
    err: data?.err,
  };
}

function getSessionAuthUrl(): string {
  const { baseUrl } = getEnvSettings();
  return baseUrl + authPath.replace(/authorize$/, "session");
}
